import { Fragment } from "react";
import { TooltipWrapperSVG } from "../input-fields";
import svgKeys from "./svgKeys";

interface SvgImagesProps {
    imgKey: string,
    tooltip?: string,
    className?: string,
    wrapperClassNames?: string
};

const SvgImages = (props: SvgImagesProps) => {
    const { imgKey, className = "", tooltip, wrapperClassNames = "" } = props;
    if (imgKey) {
        return <Fragment>
            <TooltipWrapperSVG tooltipKey={tooltip} className={wrapperClassNames}>
                { svgKeys(className)?.[imgKey] || "no-img" }
            </TooltipWrapperSVG>
        </Fragment>
    }
    else return null
};

export default SvgImages;